<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="getTitle" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>

    <div @click='popupVisible()'>
      <mt-cell class="menu-item" title="العملة">{{currency}}<span class="iconfont right-arrow">&#xe600;</span></mt-cell>
    </div>

    <mt-button class="ds-button-large mt-10" type="primary" v-on:click="submit">أكّد</mt-button>

    <!--修改货币-->
    <mt-popup v-model="editMobileVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="العملة" class="common-header">
          <mt-button slot="left" icon="back" @click="editMobileVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">

        <div class="rax-view panel-container">
          <div class="rax-view rax-country-select-container">
            <div class="rax-view">
              <div class="rax-view searchContainerFixed" style="top: 12.8vw;">
                <div class="rax-view searchBar">
                  <span class="rax-text"></span>
                  <input class="searchBarText" type="search" @keyup="keyupTest" name="currency_keyword" placeholder="عملة البحث" autocorrect="off" autocomplete="off" autocapitalize="off">
                </div>
              </div>
              <div class="rax-view" style="height: 12.8vw;"></div>
            </div>
            <div class="rax-view container">
              <div class="rax-view">
                <div class="rax-view title">قائمة العملات</div>
                <div :class="'rax-view select-container-item currency_item_'+item.abbr"
                     v-for="item in currencyList"
                     v-bind:key="item.id"
                     v-on:click="changeCurrency(item.abbr, item.exchange_rate)"
                >
                  <div class="rax-view flag-title">
                    <div class="rax-view item-title-wrap">
                      <span class="rax-text item-title">{{ item.abbr }}</span>
                      <span class="rax-text item-desc rax-text--overflow-hidden rax-text--singleline">{{ item.name }}</span>
                    </div>
                  </div>
                  <div class="rax-view tag-select" :class="{'hide':currency != item.abbr}">
                    <span class="rax-text">
                      <img src="../../../assets/image/home/icon_ok.png">
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </mt-popup>
  </div>
</template>

<script>
import {Toast, Indicator} from 'mint-ui'
import $ from 'jquery'
import {editCurrency, getCurrencyInfo, getCurrencyList} from "@/api/memberCurrency";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: 'CurrencyForm',
  data() {
    return {
      editMobileVisible: false,
      currencyList: []
    }
  },
  created: function () {
    getCurrencyList().then(res => {
      this.currencyList = res.result.currency_list
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  computed: {
    getTitle() {
      return 'إعدادات العملة'
    },
    ...mapState({
      currency: state => state.currency.currency,
      exchangerate: state => state.currency.exchangerate
    })
  },
  methods: {
    ...mapMutations({
      currencyChange: 'currencyChange',
      exchangerateChange: 'exchangerateChange'
    }),
    goBack() {
      this.$router.go(-1)
    },
    submit() {
      Indicator.open()
      editCurrency(this.currency).then(
        (response) => {
          this.currencyChange(this.currency)
          Indicator.close()
          Toast('تعديل بنجاح')

          let that = this
          setTimeout(function () {
            that.$router.push({ name: 'HomeIndex' })
          }, 2000)

          //this.updateSelectedAddress()
        }, (error) => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    popupVisible() {
      this.editMobileVisible = true
    },
    keyupTest(){
      let txt_val = $.trim($('input[name=currency_keyword]').val())
      $('.select-container-item').each(function () {
        var txt_search = $(this).find('.item-title').html()
        if(txt_search.toLowerCase().indexOf(txt_val.toLowerCase()) >=0 ){
          $(this).removeClass('hide')
        }else{
          $(this).addClass('hide')
        }
      })
    },
    changeCurrency (currency, exchangerate) {
      $('.tag-select').addClass('hide')
      $('.currency_item_' + currency).find('.tag-select').removeClass('hide')
      this.currencyChange(currency)
      this.exchangerateChange(exchangerate)
      this.editMobileVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .menu-item {
    .right-arrow {
      transform: rotate(90deg);
      color: rgb(102, 102, 102);
      font-size: .8rem;
      margin-right: 0.2rem;
    }
  }
  .mint-cell-value{
    color: #666!important;
  }
  .rax-text{
    box-sizing:border-box;
    display:block;
    font-size:4.26667vw;
    /*white-space:pre-wrap;*/
  }
  .rax-text--overflow-hidden{
    overflow:hidden;
  }
  .rax-text--singleline{
    white-space:nowrap;
  }
  .rax-text--multiline{
    display:-webkit-box;
    -webkit-box-orient:vertical;
  }
  .rax-text img{
    width: 4.26667vw;
    float: left;
    margin-top: 0.8vw;
  }
  .rax-view{
    box-sizing:border-box;
    display:flex;
    position:relative;
    flex-direction:column;
    flex-shrink:0;
    align-content:flex-start;
    border:0 solid #000;
    margin:0;
    padding:0;
    min-width:0;
  }
  .searchContainerFixed {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 999
  }
  .searchContainer, .searchContainerFixed {
    flex: 1;
    background: #fff;
    box-shadow: 0 1px 0 rgba(0, 0, 0, .12)
  }
  .searchBar {
    flex: 1;
    flex-direction: row;
    height: 8.53333vw;
    margin: 2.13333vw 3.2vw 2.13333vw 4.26667vw;
    padding: 1.33333vw 3.2vw;
    background: rgba(0, 0, 0, .04);
    border-radius: 4.8vw
  }
  input::-webkit-search-cancel-button {
    display: none
  }
  input[type=search]::-ms-clear {
    display: none
  }
  .searchBarText {
    flex: 1;
    width: 6.66667vw;
    color: #999;
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-left: 1.33333vw;
    margin-right: 1.33333vw;
    margin-top: 0;
    padding: 0;
    text-overflow: ellipsis;
    outline: none;
    border: 0;
    background: transparent;
    vertical-align: top
  }
  .title {
    background: rgba(0, 0, 0, .04);
    padding: 4.5vw 3.2vw 3.13333vw;
    color: #333;
    font-size: 3.2vw;
    font-weight: 700
  }
  .select-container-item {
    justify-content: space-between;
    height: 11.73333vw;
    padding: 0 3.2vw;
    background: #fff;
    border-bottom: .13333vw solid #eee
  }
  .hide{
    display: none!important;
  }
  .flag-title, .select-container-item, .tag-select {
    display: flex;
    flex-direction: row;
    align-items: center
  }
  .tag-select {
    justify-content: flex-end
  }
  .item-flag {
    flex: 0 0 6.4vw;
    width: 6.4vw;
    height: 4.26667vw
  }
  .item-title-wrap {
    margin: 0 2.66667vw
  }
  .item-title {
    max-height: 9.6vw;
    overflow: hidden;
    color: #333
  }
  .item-desc, .item-title {
    display: flex;
    width: 72vw;
    text-overflow: "ellipsis"
  }
  .item-desc {
    color: #666;
    font-size: 2.66667vw
  }
  .item-tag {
    color: #7ed321;
    font-size: 2.66667vw;
    padding: .53333vw;
    border-radius: .53333vw;
    margin: 0 2.66667vw;
    background: #e6fbf0
  }
</style>